import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { ThemeService, ThemeMode } from '../../services/theme.service';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    MatDividerModule
  ],
  template: `
    <button 
      mat-icon-button 
      [matMenuTriggerFor]="themeMenu"
      [matTooltip]="'Toggle theme'"
      [attr.aria-label]="'Toggle theme'"
      class="theme-toggle-button">
      <mat-icon>{{ themeService.getThemeIcon() }}</mat-icon>
    </button>

    <mat-menu #themeMenu="matMenu" class="theme-menu">
      <button 
        mat-menu-item 
        (click)="setTheme('light')"
        [class.selected]="themeService.themeMode() === 'light'">
        <mat-icon>light_mode</mat-icon>
        <span>Light</span>
        <mat-icon *ngIf="themeService.themeMode() === 'light'" class="check-icon">check</mat-icon>
      </button>
      
      <button 
        mat-menu-item 
        (click)="setTheme('dark')"
        [class.selected]="themeService.themeMode() === 'dark'">
        <mat-icon>dark_mode</mat-icon>
        <span>Dark</span>
        <mat-icon *ngIf="themeService.themeMode() === 'dark'" class="check-icon">check</mat-icon>
      </button>
      
      <button 
        mat-menu-item 
        (click)="setTheme('system')"
        [class.selected]="themeService.themeMode() === 'system'">
        <mat-icon>brightness_auto</mat-icon>
        <span>System</span>
        <mat-icon *ngIf="themeService.themeMode() === 'system'" class="check-icon">check</mat-icon>
      </button>
    </mat-menu>
  `,
  styles: [`
    .theme-toggle-button {
      transition: transform 0.2s ease;
    }
    
    .theme-toggle-button:hover {
      transform: scale(1.1);
    }
    
    .theme-menu {
      min-width: 160px;
    }
    
    .theme-menu button[mat-menu-item] {
      display: flex;
      align-items: center;
      gap: 12px;
      position: relative;
    }
    
    .theme-menu button[mat-menu-item] mat-icon:first-child {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }
    
    .check-icon {
      margin-left: auto !important;
      color: var(--app-primary);
      font-size: 18px;
      width: 18px;
      height: 18px;
    }
    
    .selected {
      background-color: var(--app-surface-variant);
    }
    
    .theme-menu button[mat-menu-item]:hover {
      background-color: var(--app-surface-variant);
    }
  `]
})
export class ThemeToggleComponent {
  readonly themeService = inject(ThemeService);

  setTheme(mode: ThemeMode): void {
    this.themeService.setTheme(mode);
  }
}
